import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase-config';
import { notifyPermissionDenied } from '../core/handleCallableError';

export const getAuction = async (data) => {
  const getAuctionFn = httpsCallable(functions, 'getAuctionNewV2');
  try {
    const result = await getAuctionFn(data);
    return result.data;
  } catch (error) {
    console.error('Error al obtener la subasta:', error);
    notifyPermissionDenied(error);
    throw error;
  }
};
